import script from "./TpDocGrupoEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TpDocGrupoEditPage.vue?vue&type=script&setup=true&lang=js"

import "./TpDocGrupoEditPage.vue?vue&type=style&index=0&id=3ea616fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ea616fa"]])

export default __exports__